import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@common/directives/directives.module';
import { UIModule } from '@common/UI/UI.module';
import { CoreModule } from '@core/core.module';
import { EditorsModule } from '@routes/editors/editors.module';
import { ConfigsComponent } from './configs.component';
import { PartnersComponent } from './partners/partners.component';
import { ProductsComponent } from './products/products.component';
import { ServicesComponent } from './services/services.component';
import { SettingsComponent } from './settings/settings.component';
import { UsersComponent } from './users/users.component';
import { WarehousesComponent } from './warehouses/warehouses.component';
import { FormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';
import { ConfirmerComponent } from './products/confirmer/confirmer.component';



@NgModule({
  declarations: [
    PartnersComponent,
    ProductsComponent,
    ServicesComponent,
    ConfigsComponent,
    UsersComponent,
    SettingsComponent,
    WarehousesComponent,
    ConfirmerComponent
  ],
  imports: [
    CoreModule,
    UIModule,
    DirectivesModule,
    CommonModule,
    EditorsModule,
    RouterModule,
    FormsModule,
    NgxLoadingModule
  ],
  exports: [
    ProductsComponent
  ],
})
export class ConfigsModule { }
